import de from './de'
import en from './en'

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { de, en }
